import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Header from "../src/Components/Header";
import Navbar from "../src/Components/Navbar";
import Footer from "../src/Components/Footer";
import Slider from "../src/Components/Carousel";

import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import ExecutiveBody from "../src/Pages/ExecutiveBody";
import ExMembers from "../src/Pages/ExMembers";
import Membership from "../src/Pages/Membership";
import Aims from "../src/Pages/Aims&Obj";
import Library from "../src/Pages/Library";
import MediaGallery from "../src/Pages/MediaGallery";
import EventGallery from "../src/Pages/EventGallery";
import HighCourts from "../src/Pages/HighCourts";
import Rules from "../src/Pages/Rules";
import Notices from "../src/Pages/Notices";
import Activities from "../src/Pages/Activities";
import FAQ from "../src/Pages/FAQ";

import Contact from "../src/Pages/Contact";
import FindAdvocate from "./Pages/FindAdvocate";

function App() {
  return (
    <BrowserRouter>
      <div className="container-fluid g-0">
        <Header></Header>
        <Navbar></Navbar>
        <Slider></Slider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/ExecutiveBody" element={<ExecutiveBody />} />
          <Route path="/Membership" element={<Membership />} />
          <Route path="/Aims&Obj" element={<Aims />} />
          <Route path="/ExMembers" element={<ExMembers />} />
          <Route path="/Library" element={<Library />} />
          <Route path="/MediaGallery" element={<MediaGallery />} />
          <Route path="/EventGallery" element={<EventGallery />} />
          <Route path="/HighCourts" element={<HighCourts />} />
          <Route path="/Rules" element={<Rules />} />
          <Route path="/Notices" element={<Notices />} />
          <Route path="/Activities" element={<Activities />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/Contact" element={<Contact />} />
          {/* <Route path="/FindAdvocate" element={<FindAdvocate />} /> */}
        </Routes>
        <Footer></Footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
